export const statusCheckHandler = (reports) => {
  let statuses = [];
  let riskFactor = "";

  // Common invalid results
  const isInvalid = (result) =>
    result === "" || result === "N/A" || result === "---" || result === "NAD";

  // Helper function to set status and append risk factor
  const setStatusBasedOnResult = (
    result,
    normalValue,
    name,
    makeUnfit = true
  ) => {
    if (result === normalValue || isInvalid(result)) {
      statuses.push(2); // Fit
      return 2;
    }

    if (makeUnfit) {
      statuses.push(3); // Unfit
      riskFactor += `<span style="color: #FF0000;">${name}</span>, `;
      return 3;
    } else {
      statuses.push(4); // Held Up
      riskFactor += `<span style="color: #0000FF;">${name}</span>, `;
      return 4;
    }
  };

  // Process each report
  reports.forEach((report) => {
    const { investigation_id, result } = report;

    switch (investigation_id) {
      case 8: // Right Eye
        report.status = setStatusBasedOnResult(
          result,
          "6/6",
          "Right Eye",
          true
        );
        break;

      case 7: // Left Eye
        report.status = setStatusBasedOnResult(result, "6/6", "Left Eye", true);
        break;

      case 10: // Right Ear
        report.status = setStatusBasedOnResult(
          result,
          "Normal",
          "Right Ear",
          false
        );
        break;

      case 9: // Left Ear
        report.status = setStatusBasedOnResult(
          result,
          "Normal",
          "Left Ear",
          false
        );
        break;

      case 14: // Physical
        report.status = setStatusBasedOnResult(
          result,
          "Normal",
          "Physical",
          false
        );
        break;

      case 57: // C.N.S
        report.status = setStatusBasedOnResult(
          result,
          "Normal",
          "C.N.S",
          false
        );
        break;

      case 13: // Skin
        report.status = setStatusBasedOnResult(result, "Clear", "Skin", true);
        break;

      case 11: // Hernia
        report.status = setStatusBasedOnResult(
          result,
          "Absent",
          "Hernia",
          true
        );
        break;

      case 12: // Hydrocele
        report.status = setStatusBasedOnResult(
          result,
          "Absent",
          "Hydrocele",
          true
        );
        break;

      case 56: // Deformities
        report.status = setStatusBasedOnResult(
          result,
          "Absent",
          "Deformities",
          true
        );
        break;

      case 58: // Extremities
        report.status = setStatusBasedOnResult(
          result,
          "Absent",
          "Extremities",
          true
        );
        break;

      case 60: // Age Determinations
        report.status = setStatusBasedOnResult(
          result,
          "Normal",
          "Age Determinations",
          true
        );
        break;

      default:
        break;
    }
  });

  // Determine final status based on priority (Unfit > Held Up > Fit > default)
  let finalStatus;
  if (statuses.includes(3)) {
    finalStatus = 3;
  } else if (statuses.includes(4)) {
    finalStatus = 4;
  } else if (statuses.includes(2)) {
    finalStatus = 2;
  } else {
    finalStatus = 1;
  }

  // Remove trailing comma and space from risk factor
  riskFactor = riskFactor.replace(/, $/, "");

  return {
    status: finalStatus,
    riskFactor,
    reports,
  };
};

// Example usage:
// const testReports = [
//   { investigation_id: 8, result: "6/9" },
//   { investigation_id: 9, result: "Abnormal" },
// ];
// const result = statusCheckHandler(testReports);
// console.log(result);
